export default {
    methods: {
        goToStatistics(item){
            const harmonyUrl = `${window.location.origin}/panel/admin/stats?id=${item.site_id}&user_id=${item.user_id}&name=${encodeURIComponent(item.site_name)}`;
            window.open(harmonyUrl, '_blank');
        },
        goToTheStatistics(item) {
            const harmonyUrl = `${window.location.origin}/panel/admin/stats?id=${item.id}&user_id=${item.user.id}&name=${encodeURIComponent(item.name)}`;
            window.open(harmonyUrl, '_blank');
        },
        goToStatisticsVar(site_id, user_id, site_name) {
            const harmonyUrl = `${window.location.origin}/panel/admin/stats?id=${site_id}&user_id=${user_id}&name=${encodeURIComponent(site_name)}`;
            window.open(harmonyUrl, '_blank');
        }
    }
}